import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import GeneralCompanyInformation from './general_company_information/GeneralCompanyInformation';
import ProjectOverview from './project_overview/ProjectOverview';
import ProjectDetailTabs from './project_detail/ProjectDetailTabs';
import ManagementTab from './ManagementTab';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import elsterProjectsService from '../../services/elster/elster_projects.service';
import EligibleExpenses from './general_company_information/EligibleExpenses';
import { cardHeaderText } from './company_costs/cardHeaderText';
const CompanyCosts = _ref => {
  let {
    elster,
    setElster,
    handleToaster,
    fetchElster,
    fetchCompanyMenu,
    paramForCompanyMenuFetch
  } = _ref;
  const [loading, setLoading] = useState(false);
  const accountType = useSelector(state => state.auth.user.account_type);
  const [key, setKey] = useState('project_overview');
  const [projectReports, setProjectReports, fetchAllProjetcs] = elsterProjectsService.useFetchAll({
    elsterId: elster.id,
    accountType,
    setLoading
  });
  const [wageCosts, setWageCosts] = useState(elster.wage_cost);
  const [affiliates, setAffiliates] = useState(elster.affiliate);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedProject, setSelectedProject] = elsterProjectsService.useGet(elster.id, selectedProjectId);
  const history = useHistory();
  const {
    search
  } = useLocation();
  const {
    t
  } = useTranslation();
  const financialYear = elster.start_date.slice(-4);
  const goToTab = key => {
    setKey(key);
    let subTabKey = 'none';
    if (key == 'project_details') {
      subTabKey = 'employee';
    } else {
      subTabKey = 'affiliates';
    }
    history.push({
      search: "?main_tab=".concat(key, "&sub_tab1=").concat(subTabKey, "&p_id=").concat(selectedProjectId || '')
    });
  };
  useEffect(() => {
    const main_tab = new URLSearchParams(search).get('main_tab');
    const pId = new URLSearchParams(search).get('p_id');
    if (pId) {
      setSelectedProjectId(pId);
    }
    if (!main_tab) {
      history.push({
        search: "?main_tab=".concat(key)
      });
    } else {
      setKey(main_tab);
    }
  }, [history, key, search]);
  if (loading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Header, null, cardHeaderText(t('elster_main_header_company_costs_fiscal_period'), elster)), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    onSelect: goToTab,
    className: "mb-3",
    activeKey: key,
    defaultActiveKey: 'project_overview'
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_overview",
    title: t('project_overview')
  }, /*#__PURE__*/React.createElement(ProjectOverview, {
    claimProjectReports: projectReports,
    financialYear: financialYear,
    elster: elster,
    setElster: setElster,
    fetchAllProjetcs: fetchAllProjetcs,
    fetchElster: fetchElster,
    fetchCompanyMenu: fetchCompanyMenu,
    paramForCompanyMenuFetch: paramForCompanyMenuFetch,
    loading: loading,
    setLoading: setLoading
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "general_company_information",
    title: t('general_company_information')
  }, /*#__PURE__*/React.createElement(GeneralCompanyInformation, {
    wageCosts: wageCosts,
    setWageCosts: setWageCosts,
    financialYear: financialYear,
    affiliates: affiliates,
    setAffiliates: setAffiliates,
    elster: elster,
    selectedProject: selectedProject
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_details",
    title: t('project_details')
  }, /*#__PURE__*/React.createElement(ProjectDetailTabs, {
    setSelectedProject: setSelectedProject,
    selectedProject: selectedProject,
    setProjectReports: setProjectReports,
    projectReports: projectReports,
    handleToaster: handleToaster,
    elster: elster,
    setElster: setElster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "summary",
    title: t('summary')
  }, /*#__PURE__*/React.createElement(EligibleExpenses, {
    financialYear: financialYear,
    search: search,
    elsterId: elster.id,
    elster: elster
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "management",
    title: t('management')
  }, /*#__PURE__*/React.createElement(ManagementTab, {
    elster: elster,
    setElster: setElster,
    fetchCompanyMenu: fetchCompanyMenu,
    paramForCompanyMenuFetch: paramForCompanyMenuFetch
  })))));
};
export default CompanyCosts;